import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiwrapperService } from '../../../services/apiwrapper.service';
import { DataManipulationService } from '../../../services/data-manipulation.service';

@Component({
  selector: 'app-role-request-modal',
  templateUrl: './role-request-modal.component.html',
  styleUrls: ['./role-request-modal.component.scss']
})
export class RoleRequestModalComponent {

  constructor(private dialogRef: MatDialogRef<any>, public apiwrapper: ApiwrapperService,
              public data: DataManipulationService) { }

  close(result?: any) {
    this.dialogRef.close(result);
  }

  requestRole() {
    this.data.showLoading()
    this.apiwrapper.postRequestRole(this.data.roleWorkspaceAdmin).subscribe(
      () => {
        this.data.hideLoading();
        this.data.showAlert('Request administrator role sent');
        this.close(true);
      }, error => {
        this.data.hideLoading();
        console.log(error)
      }
    )
  }
}
